<mat-toolbar class="nav-bar-mobile-container">
  <button mat-icon-button (click)="onOpenSideNav()" id="mainMenu" class="user-profile-menu" >
    <mat-icon>menu</mat-icon>
  </button>
  @if (isSearchRoute()) {
    <span class="nav-bar-title">Welcome to Aviation Directory</span>
  }
  @if (isAllContactsRoute()) {
    <span class="nav-bar-title">Contacts</span>
  }
  <!-- make variable driven?  add back button up here for profile page -->
  <span class="nav-bar-mobile-spacer"></span>
  @if (!isSearchRoute()) {
    <button mat-button matTooltip="Back To User Search Page" class="user-profile-back-to-search" (click)="backToSearchResults()">
      <mat-icon>arrow_back</mat-icon>
      <span>New Search</span>
    </button>
  }

</mat-toolbar>
